<h2 class="font-weight-normal default-dialog-header" mat-dialog-title>
	<span fxFlex>{{data.title}}</span>
	<span fxFlex fxLayoutAlign="end end">
		<mat-icon (click)="closeDialog()" class="primary-light-color cursor-pointer">close</mat-icon>
	</span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content font-size-12">
	<div *ngIf="data.changeDueDate" class="m-t-1" fxFlex fxLayoutAlign="center center">
		<mat-form-field fxFlex="90">
			<input
				(click)="picker.open()"
				(dateChange)="updateDueDate($event)"
				[formControl]="dueDate"
				[matDatepicker]="picker"
				[min]="minimumDueDate"
				matInput
				placeholder="Due Date"
			/>
			<mat-datepicker-toggle [for]="picker" matSuffix tabIndex="-1"></mat-datepicker-toggle>
			<mat-datepicker #picker></mat-datepicker>
		</mat-form-field>
		<mat-icon
			(click)="clear(dueDate)"
			*ngIf="dueDate.value"
			class="danger-text cursor-pointer top-fix"
			fxFlex="10"
			fxLayoutAlign="end end"
		>
			close
		</mat-icon>
	</div>
	<div *ngIf="data.changeProject" class="m-t-1" fxFlex fxLayoutAlign="center center">
		<app-project-selector
			(projectSelectedEvent)="projectSelected($event)"
			[accountId]="data.accountId"
		>
		</app-project-selector>
	</div>
	<div *ngIf="data.changeCarrier" class="m-t-1" fxFlex fxLayoutAlign="center center">
		<app-carrier-search
			(updatedCarrier)="carrierSelected($event)"
			*ngIf="this.utilService.isNullOrUndefined(data.projectId)"
			[isForTasks]="true"
			class="full-width"
		>
		</app-carrier-search>
		<app-carrier-selector
			(updatedCarrier)="carrierSelected($event)"
			*ngIf="!this.utilService.isNullOrUndefined(data.projectId)"
			[projectId]="data.projectId"
			[useAutoComplete]="true"
			fxFlex
		></app-carrier-selector>
	</div>

	<div *ngIf="data.changeAssignee" class="m-t-1" fxFlex fxLayoutAlign="center center">
		<app-user-selector
			(userChanged)="setAssignee($event)"
			[showAssignMe]="true"
			[singleselect]="true"
			fxFlex
		></app-user-selector>
	</div>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<div fxFlex="100" fxLayoutAlign="end end">
		<button (click)="updateTasks()" [disabled]="disableUpdate()" color="primary" mat-raised-button>
			Update
		</button>
	</div>
</mat-dialog-actions>
